import React, { useEffect, useState } from 'react'
import useHttp from '../../../hooks/use-http';
import Input from "../../UI/Input";
import { endPoints } from "../../../config/end-points"
import { cuteToast } from '../../UI/cute';
import { useDispatch, useSelector } from 'react-redux';
import { settingAction } from "../../../store/setting-store";
import UploadService from "../../../Services/FileUploadServices";
import { BiTrash } from 'react-icons/bi';

const SubdomainConfigure = () => {

    const {sendRequest: insertSubdomainDetails} = useHttp();
    const {sendRequest: getSubdomainData} = useHttp();
    const dispatch = useDispatch();
    const [errors, setErrors] = useState({});

    const token = useSelector((state) => state.auth.token);
    const All_access = useSelector((state) => state.settings.all_access_details);
    // const [subaccess, setSubaccess] = useState({});
    

    const [productListsStatus, setProductListsStatus] = useState(false);

    const [details, setDetails] = useState({
        subdomainName: "",
        subdomainDesc: "",
        subdomainLogo: "",
        subdomainFavicon: "",
        // subdomainAccess: ""
    });

    const [lists, setLists] = useState({});

    useEffect(() => {
        getSubdomainData({
            url: endPoints.getProductDetails,
            method: "GET",
        }, (response) => {
            if (response.status === 200 && response.body.length > 0) {
                const result = response.body;
                setLists(result)
                dispatch(settingAction.setSubdomain_list({ subdomain_list: result}));
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productListsStatus]);


    // const checkAccess = (access1) => {
    //     // return access;
    //     // console.log(access1);
    //     if ( details.subdomainAccess && details.subdomainAccess.includes(access1))  return "checked";
    //   };

    // const handleChange = (e, access_id) => {

    //     const subaccess = (details.subdomainAccess)?details.subdomainAccess:"";
    //     var new_Access = subaccess.split(",");
    
    //     if (e.target.checked) {
    //       setDetails({...details, subdomainAccess: subaccess + access_id + ","});
    //     } else {
    //       var new_Access1 = new_Access.filter((access) => {
    //         return parseInt(access) !== parseInt(access_id);
    //       });

    //       setDetails({...details, subdomainAccess: new_Access1.toString()});
    //     }
    //     // console.log(access);
    //   };

    const handleSubdomainChange = (event) => {

        const { value } = event.target;   
        // console.log(lists)
        const subdomain_detail = lists.find(element => element.subdomain_name === value);
        // console.log(All_access)
        // setSubaccess(All_access.filter(element => element.product_name === value))

        if(subdomain_detail){
            setDetails({
                subdomainName: JSON.parse(subdomain_detail.meta_data).subdomainName,
                subdomainDesc: JSON.parse(subdomain_detail.meta_data).subdomainDesc,
                subdomainLogo: JSON.parse(subdomain_detail.meta_data).subdomainLogo,
                subdomainFavicon: JSON.parse(subdomain_detail.meta_data).subdomainFavicon,
                // subdomainAccess: subdomain_detail.product_access
            });
        }else{
            setDetails({
                subdomainName: "",
                subdomainDesc: "",
                subdomainLogo: "",
                subdomainFavicon: "",
                // subdomainAccess: ""
            });
        }

       
    };

    const handleImageChange = async (event , type) => {
        // console.log('joo');
        try {
          if (checkFileSize(event) && checkMimeType(event)) {
            // EditorContextData.loadingHandler(true);
            // document.getElementById("imageglrybx").classList.remove('show');
            // console.log(event.target.files[0]);
            // let imageDataUrl = await readFile(event.target.files[0]);
    
            UploadService.upload(event.target.files[0], token, (event) => {
              console.log(Math.round((100 * event.loaded) / event.total));
            })
            .then((response) => {
              // console.log(response.status);
              const imgLink = response.data.url;
              if (response.status === 200) {
                if(type === "subdomainLogo"){
                    setDetails({ ...details, subdomainLogo: imgLink });
                }else{
                    setDetails({ ...details, subdomainFavicon: imgLink });
                }
                
              }
            })
    
            // EditorContextData.loadingHandler(false);
    
            event.target.value = "";
          }
        } catch (err) {
          console.log(err);
        }
    };

    const checkMimeType = (event) => {
        //getting file object
        let files = event.target.files;
        //define message container
        let err = "";
        // list allow mime type
        const types = ["image/png", "image/jpeg", "image/gif"];
        // loop access array
    
        //    console.log(files.length);
        if (types.every((type) => files[0].type !== type)) {
          // create error message and assign to container
          err +=
            files[0].type +
            " is not a supported format\n please upload JPG/PNG Images";
        }
    
        if (err !== "") {
          // if message not same old that mean has error
          event.target.value = null; // discard selected file
          // console.log(err)
          cuteToast({
            type: "error",
            message: err,
            timer: 5000,
            title: "",
          });
          return false;
        }
        return true;
    };
    
    const checkFileSize = (event) => {
        let files = event.target.files;
        let size = 2000000;
        let err = "";
        for (var x = 0; x < files.length; x++) {
          // console.log(files[x].size);
          if (files[x].size > size) {
            err +=
              files[x].type +
              " is too large, please pick a smaller file\n which is less than 4MB";
          }
        }
        if (err !== "") {
          event.target.value = null;
          // console.log(err)
          cuteToast({
            type: "error",
            message: err,
            timer: 5000,
            title: "",
          });
          return false;
        }
    
        return true;
    };


    const formHandler = (event) => {
        event.preventDefault();
        const validateData = validateInfo(details);
        
        if (Object.keys(validateData).length > 0) {
            setErrors(validateData);
            return false;
        } else if (Object.keys(validateData).length === 0) {
            dispatch(settingAction.setSubdomainDetails({ subdomain_details:details}));

            insertSubdomainDetails({
                url: endPoints.updateProductDetails,
                method: "POST",
                body: {...details},
            },(response)=>{
                if(response.status === 200){
                    cuteToast({
                        type: "success",
                        message: "Created Successfully.",
                        timer: 5000,
                        title: "Subdomain",
                    });

                    setProductListsStatus(!productListsStatus)
                }
            })
        }
    }

    const handleDeleteImage = (e,type) => {
        e.preventDefault();
        if(type === "subdomainLogo"){
            setDetails({ ...details, subdomainLogo: "" });
        }else{
            setDetails({ ...details, subdomainFavicon: "" });
        }

    }

    function validateInfo(values) {
        let errors = {};
        
        if(!values.subdomainLogo){
          errors.subdomainLogo = 'Please upload Logo Image!';
        }

        if(!values.subdomainFavicon){
            errors.subdomainFavicon = 'Please upload Favicon';
          }

        if(!values.subdomainName){
          errors.subdomainName = 'Subdomain Name Required!';
        }

        if(!values.subdomainDesc){
            errors.subdomainDesc = 'Subdomain Description Required!';
        }
      
        return errors;
    }
    
  return (
    <div className="col-md-12 mb-4">
        <div className="bx_a">
            <h5 className="mb-4 pb-3 small_title d-flex">
                Product Settings
            </h5>
            <h6 className="small_title d-flex">
                Subdomain Details:
            </h6>
            <form onSubmit={formHandler}>
                <div className="form-row row">
                    <div className="form-group col-md-6">
                        <label htmlFor="inputName" className='h6'>Subdomain List *:</label>
                        <select
                            type="text"
                            className="form-control"
                            onChange={handleSubdomainChange}
                        >
                            <option value="">Select Subdomain</option>
                            {lists && lists.length > 0 && lists.map((item, index) => {

                                return (
                                    <option key={index} value={item.subdomain_name}>{item.subdomain_name}</option>
                                )
                            })
                            }

                        </select>
                    </div>
                </div>
                <div className="form-row row">
                    <div className="form-group col-md-6">
                        <label htmlFor="inputName" className='h6'>Subdomain Name *:</label>
                        <Input
                            type="text"
                            inputClass="form-control mb-4"
                            value={details.subdomainName}
                            id="inputName"
                            placeholder="Enter Your Subdomain Name..."
                            onChange={(e) =>
                                setDetails({ ...details, subdomainName: e.target.value })
                            }
                        />

                        <label htmlFor="inputEmail4" className='h6'>Subdomain Desc *:</label>
                        <textarea
                            type="text"
                            className="form-control height146 mb-4"
                            value={details.subdomainDesc}
                            id="inputEmail4"
                            placeholder="Enter Your Description..."
                            onChange={(e) =>
                                setDetails({ ...details, subdomainDesc: e.target.value })
                            }
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="inputName" className='h6'>Logo *:</label>
                        <input
                            className={`form-control mb-4 font12 ${
                              errors && errors.subdomainLogo ? "is-invalid" : ""
                            }`}
                            type="file"
                            onChange={(e)=>handleImageChange(e,"subdomainLogo")}
                        />
                        {details.subdomainLogo && (
                            <div className='position-relative previewSubdomainImage'>
                                <img 
                                    src={details.subdomainLogo} 
                                    alt="subdomainLogo" 
                                    className="img-fluid" 
                                    // style={{width: "50px"}} 
                                />
                                <span className="text-danger" onClick={(e)=>handleDeleteImage(e,"subdomainLogo")}><BiTrash /></span>
                            </div>
                        )}

                        <label htmlFor="inputName" className='h6'>FavIcon *:</label>
                        <input
                            className={`form-control mb-4 font12 ${
                              errors && errors.subdomainFavicon ? "is-invalid" : ""
                            }`}
                            type="file"
                            onChange={(e)=>handleImageChange(e,"subdomainFav")}
                          />
                          {details.subdomainFavicon && (
                            <div className='position-relative previewSubdomainImage'>
                                <img 
                                    src={details.subdomainFavicon} 
                                    alt="subdomainLogo" 
                                    className="img-fluid" 
                                    // style={{width: "50px"}} 
                                />
                                <span className="text-danger" onClick={(e)=>handleDeleteImage(e,"subdomainFav")}><BiTrash /></span>
                            </div>
                          )}

                    </div>  
                </div>

                <div className="col-md-12">
                    <h6>Access : </h6>
                    <ul>
                    { details.subdomainName && Object.keys(All_access).map((item, index) => {
                        const access_names = All_access[item].access_name;
                        const baseAccess = All_access[item].baseAccess;
                        
                        // const check = checkAccess(baseAccess);
                        const check = true;

                        if( All_access[item].product_name !== details.subdomainName){
                            return (null);
                        }
                        // console.log(All_access[item].product_name)

                        return (
                        <li key={index} className="access_span">
                            {check && (
                            <input
                                type="checkbox"
                                value={baseAccess}
                                // checked
                                defaultChecked
                                disabled
                                // onChange={(e) => { handleChange(e, baseAccess); }}
                            />
                            )}
                            {!check && (
                            <input
                                type="checkbox"
                                value={baseAccess}
                                // onChange={(e) => { handleChange(e, baseAccess); }}
                            />
                            )}{" "}
                            
                            {access_names}
                        </li>
                        );
                    })}
                    </ul>
                </div>
                
                <div className="form-group d-flex justify-content-end">
                    <button className='btn mt-4 w-25' type='submit'>Save Details</button>
                </div>  
            </form>
        </div>
    </div>
  )
}

export default SubdomainConfigure